import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  root: {
    marginTop: '2rem',
    padding: '30px 45px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    margin: '0px',
    fontSize: '24px',
  },
  label: {
    marginRight: '26px',
  },
  rightBock: {
    display: 'flex',
  },
  currencySelectInput: {
    width: '100px',
  },
}));
